export const joinClasses = (...args: (string | undefined | false | null)[]) => {
  return args.filter(Boolean).join(' ')
}
